import { Controller } from "@hotwired/stimulus"

// Base controller for inheritance
// You can add common logic for all controllers here
export default class extends Controller {
  // Helper method for dispatching custom events
  dispatch(eventName, detail = {}) {
    this.element.dispatchEvent(new CustomEvent(eventName, {
      detail,
      bubbles: true,
      cancelable: true
    }))
  }
}
